
















































































































/**
    * Typescript properties & events
 */
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

@Component({
  components: {
    LeafRow: () => import("./LeafRow.vue"),
    Measures: () => import("./Measures.vue")
  }
})
export default class ImpactTable extends  Vue {

/**
    * Properties
 */
    @Prop({ default: true }) startingPeriod: boolean;
    @Prop() modelWrapper: any;
    @Prop() selectedKey: any;
    @Prop({ default: {} }) formOptions: any;

    hiddenChild: any = [];

    /** results */
    get results() {
        return this.modelWrapper[this.selectedKey].filter(x=> x != null);
    }

    /** show/hide table rows */
    toggleVisibility(data) {
        if (this.hiddenChild.includes(data)) {
        // show hidden row
        const index = this.hiddenChild.indexOf(data);
        this.hiddenChild.splice(index, 1);
        } else {
        this.hiddenChild.push(data); // adding new hidden row
        }
    }    
}
